export function interceptor2Chain(interceptors, first, last, defaultOrder) {
    let chain = last
    for (const interceptor of [
        first,
        ...interceptors
            .filter((it) => !!it)
            .sort(({ order: order1 = defaultOrder }, { order: order2 = defaultOrder }) => order1 - order2),
    ].reverse()) {
        const function_ = typeof interceptor === 'function' ? interceptor : interceptor.interceptor
        const _chain = chain
        chain = (request) => function_(request, _chain)
    }

    return chain
}
